import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children?: ReactNode;
}
interface State {
  hasError: boolean;
  info?: any;
}

export default class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    info: null,
  };

  constructor(props: any) {
    super(props);

    this.state = {
      hasError: false,
      info: null,
    };
  }

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ info: errorInfo });
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div
          className="text-center text-danger"
          style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}
        >
          <h6>Sorry.. there was an error</h6>
          <br />
          <div style={{ width: 500 }}>
            <small>{JSON.stringify(this.state.info)}</small>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
